import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useGetAllHubspotPlaylistsAdmin } from '../../hubspotPlaylistQueries';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import NoResultsError from '../../../../components/Errors/NoResultsError';
import ACBadRequestError from 'academy-common-lib/components/error/ACBadRequestError';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { LearningContentCard } from 'academy-common-lib/features/learningContentCard/components/LearningContentCard';
import { scrollPageToTop } from 'academy-common-lib/utils/scrolling';
import { FiltersCard } from '../../../filters/components/FiltersCard';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PAGE_LENGTH = 12;
const publishedFilterOptions = {
  ALL: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.playlists.hubspotPlaylists.admin.publishedFilter.all"
  }),
  PUBLISHED: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.playlists.hubspotPlaylists.admin.publishedFilter.published"
  }),
  UNPUBLISHED: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.playlists.hubspotPlaylists.admin.publishedFilter.unpublished"
  })
};
const HubspotPlaylistsAdminList = () => {
  const {
    allHubspotPlaylists,
    allHubspotPlaylistsLoading,
    allHubspotPlaylistsError
  } = useGetAllHubspotPlaylistsAdmin();
  const [searchTerm, setSearchTerm] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const [publishFilter, setPublishFilter] = useState('ALL');
  if (allHubspotPlaylistsLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium"
    });
  }
  if (allHubspotPlaylistsError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "HUBSPOT_PLAYLISTS_ADMIN_API_ERROR",
      children: /*#__PURE__*/_jsx(ACBadRequestError, {
        to: '/hubspot-playlists-admin'
      })
    });
  }
  const filteredPlaylists = Object.values(allHubspotPlaylists).filter(playlist => `${playlist.name}${playlist.description}`.toLowerCase().includes(searchTerm.trim().toLowerCase())).filter(playlist => publishFilter === 'ALL' ? true : publishFilter === 'PUBLISHED' ? playlist.active : !playlist.active);
  const pageCount = Math.ceil(filteredPlaylists.length / PAGE_LENGTH);
  const paginatedPlaylists = filteredPlaylists.slice((pageNumber - 1) * PAGE_LENGTH, pageNumber * PAGE_LENGTH);
  const startIndex = (pageNumber - 1) * PAGE_LENGTH + 1;
  const endIndex = Math.min(pageNumber * PAGE_LENGTH, filteredPlaylists.length);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myLearning.paginatedResultsCount",
        options: {
          startCard: startIndex,
          endCard: endIndex,
          cardsTotal: filteredPlaylists.length
        }
      })
    }), /*#__PURE__*/_jsxs(FiltersCard, {
      children: [/*#__PURE__*/_jsx(SearchInput, {
        marginInlineEnd: "600",
        maxInlineSize: "300px",
        onChange: e => {
          setSearchTerm(e.target.value);
          setPageNumber(1);
        },
        value: searchTerm
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.hubspotPlaylists.admin.publishedFilter.label"
      }), /*#__PURE__*/_jsx(Dropdown, {
        buttonText: publishedFilterOptions[publishFilter],
        buttonUse: "transparent",
        menuWidth: 150,
        children: /*#__PURE__*/_jsxs(List, {
          children: [/*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(Button, {
              onClick: () => setPublishFilter('ALL'),
              children: publishedFilterOptions.ALL
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(Button, {
              onClick: () => setPublishFilter('PUBLISHED'),
              children: publishedFilterOptions.PUBLISHED
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(Button, {
              onClick: () => setPublishFilter('UNPUBLISHED'),
              children: publishedFilterOptions.UNPUBLISHED
            })
          })]
        })
      })]
    }), filteredPlaylists.length === 0 ? /*#__PURE__*/_jsx(NavMarker, {
      name: "HUBSPOT_PLAYLISTS_ADMIN_API_404",
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        marginBlockEnd: "1300",
        children: /*#__PURE__*/_jsx(View, {
          textAlign: "center",
          children: /*#__PURE__*/_jsx(NoResultsError, {
            onReset: () => {
              setSearchTerm('');
              setPageNumber(1);
              setPublishFilter('ALL');
            },
            resetLink: '/hubspot-playlists-admin'
          })
        })
      })
    }) : /*#__PURE__*/_jsx(NavMarker, {
      name: "HUBSPOT_PLAYLISTS_ADMIN_LOADED",
      children: /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "1300",
        children: /*#__PURE__*/_jsx(CardGrid, {
          columnSize: 300,
          gutterSize: 32,
          children: paginatedPlaylists.map(playlist => /*#__PURE__*/_jsx(LearningContentCard, {
            isGhost: !playlist.active,
            item: Object.assign({}, playlist, {
              id: playlist.playlistId,
              type: 'LEARNING_PATH',
              progress: null
            }),
            playlistId: playlist.playlistId
          }, playlist.playlistId))
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "1200",
      children: /*#__PURE__*/_jsx(Paginator, {
        defaultPage: 1,
        onPageChange: ({
          target: {
            value
          }
        }) => {
          setPageNumber(value);
          scrollPageToTop();
        },
        pageCount: pageCount,
        showFirstLastButtons: true
      })
    })]
  });
};
export default HubspotPlaylistsAdminList;